import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
}

/** The onboarding step card: raised paper with a hairline, like every other panel. */
export function GlassCard({ children, className = '' }: GlassCardProps) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={{ opacity: 0, y: reduce ? 0 : 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: reduce ? 0 : -8 }}
      transition={{ duration: 0.26, ease: [0.22, 1, 0.36, 1] }}
      className={`w-full max-w-[720px] rounded-panel border border-line bg-paper-raised px-10 py-12 text-ink shadow-float ${className}`}
    >
      {children}
    </motion.div>
  );
}
